// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610232050/js/" + chunkId + "." + {"44":"c0775fd8","225":"28638f74","481":"fef2cad1","486":"523d6196","770":"3c4eb0a6"}[chunkId] + ".0.2511718726402724.chunk.js";
};